export async function refreshToken() {
    try {
      const response = await fetch(process.env.VUE_APP_API_URL + "api/god/auth/refresh_token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        },
        body: JSON.stringify({
          "user_id": localStorage.getItem('user_id')
        }),
      });
  
      if (!response.ok) {
        return false;
      }
  
      const data = await response.json();
  
      if (data.errors) {
        return false;
      } else {
        localStorage.setItem('token', data.token);
        return true;
      }
    } catch (error) {
      return false;
    }
  }
  